module.exports = {
	props: {
		"trueText": String,
		"falseText": String,
		"value": Boolean,
	},
  
  data: function () {
    return {
    }
  },

  computed: {
  	displayText: function() {
  		if(this.chosenOption==null) {
  			return this.desc
  		} else {
  			return this.chosenOption.text
  		}
  	}
  },

  methods: {
  	onSwitch: function() {
  		this.value = !this.value
  	},
  },
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/controls/custom-switch.vue
// module id = 149
// module chunks = 0